import { render } from "./FormPage.vue?vue&type=template&id=c1668568&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"

import "./FormPage.vue?vue&type=style&index=0&id=c1668568&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-c1668568"

export default script